import { useFetchCommonApiQuery } from "@/api/services/commonApi/CommonApi";

const useFetchCommonData = (endpoint, params = {}) => {
  return useFetchCommonApiQuery({ endpoint, params });
};

export default useFetchCommonData;
  